const REDIRECT_KEY = 'bs-talent-auth-redirect'

export function rememberAuthRedirect(path: string) {
  if (isSafeRedirect(path) && !path.startsWith('/login')) {
    window.sessionStorage.setItem(REDIRECT_KEY, path)
  }
}

export function consumeAuthRedirect(fallback = '/jobs') {
  const redirect = window.sessionStorage.getItem(REDIRECT_KEY)
  window.sessionStorage.removeItem(REDIRECT_KEY)
  return redirect && isSafeRedirect(redirect) ? redirect : fallback
}

function isSafeRedirect(path: string) {
  return path.startsWith('/') && !path.startsWith('//')
}
